import { connect } from 'react-redux';
import { List } from 'immutable';
import moment from 'moment';

import {
  loadSms,
  updateSms,
  deleteSms,
  smsFormDestroy,
} from '../../../../../state/modules/smses/actions';
import { sendMessage } from '../../../../../state/actions';
import SmsForm from '../components/SmsForm';
import Config from '../../../../../Config';

const inputs = List([
  'service_id',
  'priority',
  'send_status',
  'attempts',
  'queued_at',
  'body',
  'last_attempt_at',
  'recipients',
  'total_count',
  'total_sent_count',
  'total_delivered_count',
  'total_delivery_failed_count',
]);

const mapStateToProps = (state, ownProps) => {
  const data = {},
    errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(['smses', ownProps.id, val], '');
    errors[val] = state.smses.getIn(['form', 'errors', val]);
  }
  data['last_attempt_at'] = data['last_attempt_at']
    ? moment(data['last_attempt_at'], Config.get('API_DATETIME_FORMAT'))
    : null;

  data['queued_at'] = data['queued_at']
    ? moment(data['queued_at'], Config.get('API_DATETIME_FORMAT'))
    : moment();

  return {
    isLoading: state.smses.get('isLoading'),
    isSubmitting: state.smses.getIn(['form', 'isSubmitting']),
    success: state.smses.getIn(['form', 'success']),
    data: data,
    errors: errors,
    createdAt: state.entities.getIn(['smses', ownProps.id, 'created_at'], null),
    updatedAt: state.entities.getIn(['smses', ownProps.id, 'updated_at'], null),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (id, cb) => {
      dispatch(loadSms(id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateSms(id, data, cb));
    },
    delete: (id, cb) => {
      dispatch(deleteSms(id, cb));
    },
    destroyForm: (formState) => {
      dispatch(smsFormDestroy(formState));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  };
};

const SmsFormContainer = connect(mapStateToProps, mapDispatchToProps)(SmsForm);

export default SmsFormContainer;
